module.exports = __webpack_public_path__ + "static/media/neo.d44e5d7f.png";